import "bootstrap/dist/css/bootstrap.min.css";
import logo from "./logo.svg";
import "./App.css";
import React, { Component } from "react";
import Header from "./header";
import SignInScreen from "./SignInScreen";
import Footer from "./Footer";
import * as k from "./constants";
import Main from "./MainController";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authorized: false,
      username: "",
      userid: "",
      signIn: true,
      currentScreen: k.HOME,
      forgotPassword: false,
    };

    this.onChangeState = this.onChangeState.bind(this.state);
  }

  handleSignInState = (val) => {
    this.setState({
      signIn: val,
    });
  };

  handleForgotPassword = (val) => {
    this.setState({
      forgotPassword: val,
    });
  };

  handleAppsState = (name, val) => {
    this.setState({
      [name]: val,
    });
  };

  handleUpdateState = (un, uid, ath) => {
    this.setState({
      username: un,
      userid: uid,
      authorized: ath,
      signIn: false,
    });
  };

  onChangeState(val) {
    //e.preventDefault()
    this.setState(val);
  }

  render() {
    return (
      <div>
        <Header appProps={this} />
        <div
          className="container-fluid align-item-center justify-content-center"
          style={{
            maxWidth: "1140px",
            maxHeight: "100vh",
            paddingTop: k.TOPPADDING,
            paddingBottom: k.BOTPADDING,
          }}
        >
          <Main appProps={this} />
        </div>
        <Footer appProps={this} />
      </div>
    );
  }
}

export default App;
